import React from 'react';

const OrderReviewItem = ({ item }) => {
  const imageUrl = item.image || item.imageUrl || '/placeholder_product.png';
  const lineTotal = item.price * item.qty;

  return (
    <div className="order-review-item-row">
      <div className="review-item-product-details">
        <img 
          src={imageUrl} 
          alt={item.name} 
          className="review-item-image" 
          loading="lazy" 
        />
        <div className="review-item-info">
          <h4 className="review-item-name">{item.name}</h4>
          <div className="review-item-price-qty">
            <span className="review-item-qty">Qty: {item.qty} Pcs</span>
            <span className="review-item-divider">&bull;</span>
            <span className="review-item-price">₹{item.price.toLocaleString('en-IN')} / Pc</span>
          </div>
        </div>
      </div>
      <div className="review-item-total">
        <span className="review-item-total-label">Total </span>
        <span className="review-item-total-value">₹{lineTotal.toLocaleString('en-IN')}</span>
      </div>
    </div>
  );
};

export default OrderReviewItem;
